export const linkIncludePaths = (link: string, paths: string[] | undefined) => {
  return paths?.some((path) => {
    if (path.includes("/*")) {
      return link.includes(path.replace("/*", "/"))
    }
    return link === path
  })
}
